import api from "../../api/api";

// CREATE
export const createAdmin = async (payload) => {
  try {
    const response = await api.post("/users/admin", payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// READ ALL
export const getAllAdmins = async () => {
  try {
    const response = await api.get("/users/admin");
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

// READ BY ID
export const getAdminById = async (id) => {
  try {
    const response = await api.get(`/users/admin/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// UPDATE
export const updateAdmin = async (id, payload) => {
  try {
    const response = await api.put(`/users/admin/${id}`, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// DELETE
export const deleteAdmin = async (id) => {
  try {
    const response = await api.delete(`/users/admin/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
